import { DEFAULT_PROSODY_RATE } from "./constants";
import { TextToSpeechFormSchema } from "./types";

export const recordToSelect = (record: Record<string, string>, defaultOption?: string) => {
  return [
    {
      value: "",
      label: defaultOption ?? "Please select...",
    },
  ].concat(
    Object.entries(record).map(([key, value]) => ({
      value: key,
      label: value,
    })),
  );
};

export const getSpeedRateValue = (prosodyRate: number): string => {
  return ["0.50", "0.66", "0.84", "1.00", "1.33", "1.67", "2.00"][prosodyRate];
};

export const wrapSelectionWithColor = (source: string, selection: string, type: "old" | "new" = "new"): string => {
  let newSource = source;

  if (newSource.includes(selection)) {
    newSource = newSource.replace(
      selection,
      `<span class="cpat-selection cpat-selection--${type}">${selection}</span>`,
    );
  }

  return newSource;
};

export const getSavedVoice = (language: string) => {
  return localStorage.getItem(`savedVoice-${language}`);
};

export const getDefaultValues = (externalValues?: Partial<TextToSpeechFormSchema>): TextToSpeechFormSchema => {
  return {
    narrationText: "",
    pronunciationText: "",
    language: "en-US",
    voice: undefined,
    prosodyRate: DEFAULT_PROSODY_RATE,
    // hidden fields
    selections: [],
    generatedAudio: undefined,
    ...externalValues,
  };
};
